import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

/* istanbul ignore next */
const LeadRegister = lazy(() => import('../containers/LeadRegister'));

export default () => {
  return [<Route exact path="/boas-vindas" component={LeadRegister} key="lead-register" />];
};
